<div class="role-section">
  <p class="role-label">Inventa Owner</p>
  <mat-form-field>
    <mat-label>Email Address</mat-label>
    <input
      matInput
      type="email"
      [id]="id()"
      [formControl]="ownerControl"
      [errorStateMatcher]="matcher"
    />
    @if (ownerControl.hasError('required')) {
      <mat-error>Email is required</mat-error>
    } @else if (ownerControl.hasError('email')) {
      <mat-error>Email is invalid</mat-error>
    } @else if (ownerControl.hasError('duplicateEmail')) {
      <mat-error>This email is already assigned a role</mat-error>
    }
  </mat-form-field>
</div>

<div class="role-section">
  <p class="role-label">Device Managers</p>
  <div class="entries">
    @for (ctrl of deviceManagersArray.controls; track i; let i = $index) {
      <div class="entry-row">
        <mat-form-field>
          <mat-label>Email Address</mat-label>
          <input matInput type="email" [formControl]="ctrl" [errorStateMatcher]="matcher" />
          @if (ctrl.hasError('required')) {
            <mat-error>Email is required</mat-error>
          } @else if (ctrl.hasError('email')) {
            <mat-error>Email is invalid</mat-error>
          } @else if (ctrl.hasError('duplicateEmail')) {
            <mat-error>This email is already assigned a role</mat-error>
          }
        </mat-form-field>
        @if (!disabled()) {
          <div class="remove-btn-wrapper">
            <button mat-icon-button (click)="removeDeviceManager(i)">
              <mat-icon>remove</mat-icon>
            </button>
          </div>
        }
      </div>
    }
  </div>
  @if (!disabled() && deviceManagersArray.length < maxDeviceManagers()) {
    <button mat-button color="accent" (click)="addDeviceManager()">Add device manager</button>
  }
</div>

<div class="role-section">
  <p class="role-label">Data Managers</p>
  <div class="entries">
    @for (ctrl of dataManagersArray.controls; track i; let i = $index) {
      <div class="entry-row">
        <mat-form-field>
          <mat-label>Email Address</mat-label>
          <input matInput type="email" [formControl]="ctrl" [errorStateMatcher]="matcher" />
          @if (ctrl.hasError('required')) {
            <mat-error>Email is required</mat-error>
          } @else if (ctrl.hasError('email')) {
            <mat-error>Email is invalid</mat-error>
          } @else if (ctrl.hasError('duplicateEmail')) {
            <mat-error>This email is already assigned a role</mat-error>
          }
        </mat-form-field>
        @if (!disabled()) {
          <div class="remove-btn-wrapper">
            <button mat-icon-button (click)="removeDataManager(i)">
              <mat-icon>remove</mat-icon>
            </button>
          </div>
        }
      </div>
    }
  </div>
  @if (!disabled() && dataManagersArray.length < maxDataManagers()) {
    <button mat-button color="accent" (click)="addDataManager()">Add data manager</button>
  }
</div>
